import ISPPolicy from './ISPPolicy';
import KHDetail from './KHDetail';
import LindenDetail from './LindenDetail';
import PKPartner from './PKPartner';
import PKPolicy from './PKPolicy';

export default { LindenDetail, PKPartner, KHDetail, PKPolicy, ISPPolicy };
